import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { AccelaControlType } from '../../model/accelaControl.model';

///
///Search Page Layout component
///
/// This is a stripped down version of the page-layout component that supports advancved search
@Component({
  selector: 'search-page-layout',
  templateUrl: './search-page-layout.component.html',
  styleUrls: ['./search-page-layout.component.less']
})
export class SearchPageLayoutComponent implements AfterViewInit {

  @Input() readonlyMode = false;
  @Input() controlGroup: UntypedFormGroup;
  @Output() controlOnBlur: EventEmitter<UntypedFormControl> = new EventEmitter<UntypedFormControl>();

  controlTypes = AccelaControlType;

  @ViewChild('input') set inputElRef(elRef: ElementRef<HTMLInputElement>){
  };

  ngAfterViewInit(): void {
    if(this.inputElRef){
      this.inputElRef.nativeElement.focus();
    }

  }

  //Unsort the elements by keyvalue in FormGroup
  unsorted() {
    return 0;
  }

  onFocusChange(formRef: UntypedFormControl){
    this.controlOnBlur.emit(formRef);
  }

}
